import { render } from "./SubscriptionPlans.vue?vue&type=template&id=c59c425a"
import script from "./SubscriptionPlans.vue?vue&type=script&lang=ts"
export * from "./SubscriptionPlans.vue?vue&type=script&lang=ts"

import "./SubscriptionPlans.vue?vue&type=style&index=0&id=c59c425a&lang=scss"
script.render = render

export default script